import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'myHighlight' })
export class HighlightPipe implements PipeTransform {
  public transform(value: string = '', partial: string): string {
    const highlight = partial.replace(/[.*+?^${}()|[\]\\]/g, '');
    return value.replace(new RegExp(highlight, 'i'), '<strong>$&</strong>');
  }
}
